import { type AnalyticsEvent } from '@backstage/core-plugin-api';
import { type MetricRequest } from '@internal/plugin-neo4j-analytics-common';

import { BaseAnalyticsEventHandler } from './types';

export class SignInEventHandler extends BaseAnalyticsEventHandler {
  readonly eventName = 'signIn';
  readonly metricName = this.eventName.toLowerCase();

  canHandle(action: string): boolean {
    return action === this.eventName;
  }

  handle(event: AnalyticsEvent): MetricRequest[] {
    if (!this.canHandle(event.action)) {
      return [];
    }

    return [
      {
        kind: 'counter',
        name: this.getMetricName(this.metricName),
        value: 1,
        attributes: {
          result: event.subject,
        },
        options: {
          description: 'Total number of sign-ins',
          unit: '1',
          valueType: 'int',
        },
      },
    ];
  }
}
